export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  permissions: Array<string>
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      permissions: ['admin', 'general', 'assets', 'dashboard'],
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },

    {
      displayName: 'menu.assets',
      permissions: ['admin', 'general', 'assets'],
      meta: {
        icon: 'apartment',
      },
      children: [
        {
          name: 'company',
          displayName: 'menu.company',
          permissions: ['admin', 'company'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },

        /*
        {
          name: 'property',
          displayName: 'menu.property',
          permissions: ['admin', 'property'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
        {
          name: 'rental-unit',
          displayName: 'menu.rentalunits',
          permissions: ['admin', 'rentalunit'],
          meta: {
            icon: 'fa-house',
          },
        },
        {
          name: 'parking-lot',
          displayName: 'menu.parkinglots',
          permissions: ['admin', 'parkinglot'],
          meta: {
            icon: 'fa-house',
          },
        },
        {
          name: 'cellar',
          displayName: 'menu.cellar',
          permissions: ['admin', 'cellar'],
          meta: {
            icon: 'fa-house',
          },
        },
        {
          name: 'apartment-type',
          displayName: 'menu.apartment_type',
          permissions: ['admin', 'apartment_type'],
          meta: {
            icon: 'fa-house',
          },
        },
        */

        {
          name: 'customer',
          displayName: 'menu.customer',
          permissions: ['admin', 'customer'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
      ]
    },

    {
      name: 'tasks',
      displayName: 'menu.tasks',
      permissions: ['admin', 'tasks'],
      meta: {
        icon: 'view_kanban',
      },
    },

    /*
    {
      displayName: 'menu.appointment',
      permissions: ['admin', 'appointment'],
      meta: {
        icon: 'free_cancellation',
      },
      children: [
        {
          name: 'appointment/service',
          displayName: 'menu.appointment_service',
          permissions: ['admin', 'appointment'],
        },
        {
          name: 'appointment/user',
          displayName: 'menu.appointment_user',
          permissions: ['admin', 'appointment'],
        },
      ]
    },
    */

    {
      displayName: 'menu.racquet_sport',
      permissions: ['admin', 'racquet-sport'],
      meta: {
        icon: 'sports_tennis',
      },
      children: [
        {
          name: 'racquet-sport/brand',
          displayName: 'menu.racquet_sport_brand',
          permissions: ['admin', 'racquet-sport'],
        },
        {
          name: 'racquet-sport/model',
          displayName: 'menu.racquet_sport_model',
          permissions: ['admin', 'racquet-sport'],
        },
        {
          name: 'racquet-sport/racquet',
          displayName: 'menu.racquet_sport_racquet',
          permissions: ['admin', 'racquet-sport'],
        },
        {
          name: 'racquet-sport/string',
          displayName: 'menu.racquet_sport_string',
          permissions: ['admin', 'racquet-sport'],
        },
        {
          name: 'racquet-sport/stringing',
          displayName: 'menu.racquet_sport_stringing',
          permissions: ['admin', 'racquet-sport'],
        },
      ]
    },

    {
      displayName: 'menu.articles',
      name: 'article_container',
      permissions: ['admin', 'articles'],
      meta: {
        icon: 'inventory',
      },
      children: [
        {
          name: 'article',
          displayName: 'menu.articles_overview',
          permissions: ['admin', 'articles-overview'],
        },
        {
          name: 'category',
          displayName: 'menu.articles_categories',
          permissions: ['admin', 'articles-categories'],
        },
      ]
    },

    {
      displayName: 'menu.accounting',
      permissions: ['admin', 'general', 'accounting'],
      meta: {
        icon: 'calculate',
      },
      children: [
        {
          name: 'receivable',
          displayName: 'menu.receivable',
          permissions: ['admin', 'receivable'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
        {
          name: 'credit-note',
          displayName: 'menu.credit_note',
          permissions: ['admin', 'credit-note'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
        {
          name: 'invoice',
          displayName: 'menu.invoice',
          permissions: ['admin', 'invoice'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
        {
          name: 'bank-transfers',
          displayName: 'menu.bank_transfers',
          permissions: ['admin', 'banktransfers'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
        {
          name: 'export',
          displayName: 'menu.export',
          permissions: ['admin', 'accounting-export'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },

        /*
        {
          name: 'banking',
          displayName: 'menu.banking',
          permissions: ['banking'],
          meta: {
            icon: 'fa-money-check-dollar',
          },
        },
        */
      ]
    },

    /*
    {
      displayName: 'menu.reports',
      permissions: ['admin', 'reports'],
      meta: {
        icon: 'flag',
      },
      children: [
        {
          name: 'report-overview',
          displayName: 'menu.overview',
          permissions: ['admin', 'reports-overview'],
        },
        {
          name: 'report-general',
          displayName: 'menu.general',
          permissions: ['admin', 'reports-general'],
        },
        {
          name: 'report-apartments',
          displayName: 'menu.apartments',
          permissions: ['admin', 'reports-apartments'],
        },
        {
          name: 'report-rent-arrears',
          displayName: 'menu.rent_arrears',
          permissions: ['admin', 'reports-rent-arrears'],
        },
        {
          name: 'report-renting',
          displayName: 'menu.renting',
          permissions: ['admin', 'reports-renting'],
        },
        
        {
          name: 'report-weekly',
          displayName: 'menu.weekly_report',
          permissions: ['admin', 'reports-weekly'],
        },
        {
          name: 'report-renewal',
          displayName: 'menu.renewal_report',
          permissions: ['admin', 'reports-renewal'],
        },

        {
          name: 'report-receivables',
          displayName: 'menu.receivable',
          permissions: ['admin', 'reports-receivables'],
        },
        {
          name: 'report-rental-contracts',
          displayName: 'menu.rentalcontract',
          permissions: ['admin', 'reports-rental-contracts'],
        },
        {
          name: 'report-tenants',
          displayName: 'menu.tenant',
          permissions: ['admin', 'reports-tenants'],
        },
        {
          name: 'report-analytics',
          displayName: 'menu.analytics',
          permissions: ['admin', 'reports-analytics'],
        },
        {
          name: 'report-mailer',
          displayName: 'menu.mailer',
          permissions: ['admin', 'mailer'],
        },
        {
          name: 'report-map',
          displayName: 'menu.report_map',
          permissions: ['admin', 'map'],
        },
        {
          name: 'datev',
          displayName: 'menu.datev',
          permissions: ['admin', 'datev'],
        },
      ]
    },
    */

    {
      name: 'password',
      displayName: 'menu.password_generator',
      permissions: ['admin', 'user', 'password-generator'],
      meta: {
        icon: 'lock_reset',
      },
    },

    {
      name: 'project',
      displayName: 'menu.projects',
      permissions: ['admin', 'project'],
      meta: {
        icon: 'group_work',
      },
    },

    /*
    {
      displayName: 'menu.vacation_planning',
      permissions: ['admin', 'vacation-planning'],
      meta: {
        icon: 'houseboat',
      },
      children: [
        {
          name: 'vacation-planning-overview',
          displayName: 'menu.vacation_planning_overview',
          permissions: ['admin', 'vacation-planning-overview'],
        },
        {
          name: 'vacation-planning-application',
          displayName: 'menu.vacation_planning_application',
          permissions: ['admin', 'vacation-planning-application'],
        },
        {
          name: 'vacation-planning-examination',
          displayName: 'menu.vacation_planning_examination',
          permissions: ['admin', 'vacation-planning-examination'],
        },
      ]
    },

    {
      displayName: 'menu.time_tracking',
      name: 'time_tracking_container',
      permissions: ['admin', 'time-tracking'],
      meta: {
        icon: 'schedule',
      },
      children: [
        {
          name: 'time-tracking-overview',
          displayName: 'menu.time_tracking_overview',
          permissions: ['admin', 'time-tracking-overview'],
        },
        {
          name: 'time-tracking-track',
          displayName: 'menu.time_tracking_track',
          permissions: ['admin', 'time-tracking-track'],
        },
        {
          name: 'time-tracking-sick-notes',
          displayName: 'menu.time_tracking_sick_notes',
          permissions: ['admin', 'time-tracking-sick-notes'],
        },
        {
          name: 'time-tracking-reports',
          displayName: 'menu.time_tracking_reports',
          permissions: ['admin', 'time-tracking-reports'],
        },
      ]
    },

    {
      displayName: 'menu.employee',
      permissions: ['admin', 'employees'],
      meta: {
        icon: 'badge',
      },
      children: [
        {
          name: 'employee-overview',
          displayName: 'menu.employee',
          permissions: ['admin', 'employees'],
        },

        {
          name: 'employee-calendar',
          displayName: 'menu.employee_calendar',
          permissions: ['admin', 'employees'],
        },

        {
          name: 'employee-edit',
          displayName: 'menu.employee_edit',
          permissions: ['admin', 'employees'],
        },
      ]
    },
    */
   
    {
      name: 'settings',
      displayName: 'menu.settings',
      permissions: ['admin', 'settings'],
      meta: {
        icon: 'settings',
      },
    },

    /*
    {
      displayName: 'menu.data',
      permissions: ['admin', 'database'],
      meta: {
        icon: 'folder_open',
      },
      children: [
        {
          name: 'cpi',
          displayName: 'menu.cpi',
          permissions: ['admin', 'cpi'],
          meta: {
            icon: 'fa-house',
          },
        },
      ]
    },
    */

    /*
    {
      name: 'analytics',
      displayName: 'menu.analytics',
      permissions: ['admin', 'analytics'],
      meta: {
        icon: 'query_stats',
      },
      children: [
        {
          name: 'analytics/visitor',
          displayName: 'menu.analytics_visitor',
          permissions: ['admin', 'analytics'],
          meta: {
            icon: 'fa-calendar',
          },
        },
      ]
    },
    */
    
    {
      displayName: 'menu.admin',
      permissions: ['admin'],
      meta: {
        icon: 'admin_panel_settings',
      },
      children: [
        {
          name: 'admin/user',
          displayName: 'menu.user',
          permissions: ['admin'],
          meta: {
            icon: 'fa-calendar',
          },
        },
        {
          name: 'admin/settings',
          displayName: 'menu.settings',
          permissions: ['admin'],
          meta: {
            icon: 'fa-calendar',
          },
        },
      ]
    },

  ] as INavigationRoute[],
}
